<template>
  <div id="#step-2" class="fade-in-fwd">
    <div class="row">
      <div class="col-sm-6">
        <label for="">
          {{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProductType.Label"] }}
        </label>
        <div class="mb-2 justify-content-between align-items-center">
          <div class="input-group">
            <select
              @change="handleProductType"
              name="productType"
              :id="step2.productType"
              class="form-control form-control-sm text-uppercase"
              required="required"
              :disabled = "isDisabled"
              v-model="step2.productType"
            >
              <option value :selected="true" disabled
                >{{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProductType.Placeholder"] }}</option
              >
              <option class="dropdown-item"
                v-for="(item, index) in getContentWizardData.productType"
                :key="index"
              >
                {{ item.toLowerCase() }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <label for="">
          {{ $resourceString["myProject.Project.AddItemModal.ProductStep1.AddProduct.Label"] }}
        </label>

        <div class="mb-2  justify-content-between align-items-center">
          <div
            class="input-group-append my-project-input-container"
            @mouseout="showClearIcon = false"
            @mouseover="showClearIcon = true"
          >
            <span class="png-icon png-icon-icons-glyph--k-close my-project-search-icon my-project-clear-icon" @click="clearProductTitle"
            v-if="step2.productTitle && showClearIcon"></span>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-search my-project-search-icon"
              viewBox="0 0 16 16"
            >
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
              />
            </svg>
          </div>
          <div class="search-container d-flex flex-wrap">
            <input
              type="text"
              class="form-control my-project-add-product text-capitalize"
              :id="step2.productTitle"
              placeholder=""
              v-model="step2.productTitle"
              @input="updateSearchQuery"
              :disabled="!getisProductSearchDisabled"
              @focus="showClearIcon = true"
            />
            <ul v-if="filteredProducts.length>0"
              class="search-result-box text-capitalize p-0"
              :class="step2.productTitle ? '' : 'd-none'"
            >
              <li
                class="search-result__value p-3"
                v-for="(item, index) in filteredProducts"
                :key="index"
                @click="selectProduct(item)"
              >
                <span>{{ item.styleName + " - " + item.styleNumber }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label for="">{{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"] }}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <my-project-radio-field :options="getContentWizardData.radioOptions" name="size" v-model="step2.size"></my-project-radio-field>
      </div>

    </div>
    <div class="form-group mt-32">
      <label for="#Step2Description" class="gray-bold"
        >{{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProjectDescription.Label"] }}
        <span class="optional-field ml-3"> {{ $resourceString["contentWizard.Label.Field.Optional"] }} </span>
        </label
      >
      <my-project-description-field customClass="form-control" maxlength="400" fieldId="description" :placeholder="$resourceString['myProject.ProductItem.Description.Placeholder']" v-model="step2.description" ></my-project-description-field>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myProjectRadioField from "../../my-projects-page/my-project-radio-field.vue";
import myProjectDescriptionField from "../../my-projects-page/my-project-description-field.vue";
export default {
  components:{
    myProjectRadioField,
    myProjectDescriptionField
  },
  data() {
    return {
      step2: {
        productType: "",
        productTitle: "",
        size: 0,
        description: null,
        productInventoryType: "",
        title: "",
        productId: "",
        selectedProduct: null,
        isItemSelected: false
      },
      showClearIcon: false
    };
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getisProductSearchDisabled: "contentWizard/getisProductSearchDisabled",
      getproductSearchResponse: "contentWizard/getproductSearchResponse",
    }),

    filteredProducts() {
      let searchTerm = this.step2.productTitle.toLowerCase();
      if (Array.isArray(this.getproductSearchResponse.items)) {
        return this.getproductSearchResponse.items.filter(item => {
          if (item && item.styleName && item.styleNumber && item.colors?.length>0) {
            const nameMatches = item.styleName
              .toLowerCase()
              .includes(searchTerm);
            const numberMatches = item.styleNumber
              .toLowerCase()
              .includes(searchTerm);
            return nameMatches || numberMatches;
          } else {
            return false;
          }
        });

      } else {
        return [];
      }
    },

    isDisabled() {
      return (this.getContentWizardData.productType?.length === 0);
    }
  },
  created() {
    this.fetchProductType();
    Object.assign(this.step2, this.getContentWizardData.contentItem);
    this.setContentItem(this.step2);
    this.productType = this.getContentWizardData?.contentItem?.productType;
  },

  watch: {
    step2: {
      handler: function() {
        this.setContentItem(this.step2);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      fetchProductType: "contentWizard/fetchProductType",
      fetchproductSearch: "contentWizard/fetchproductSearch",
      updateProductSearchTerm: "contentWizard/updateProductSearchTerm",
      setContentItem: "contentWizard/setContentItem",
      selectedProduct: "contentWizard/selectedProduct",
      setStep3: "contentWizard/setStep3",
      setIsStep2ItemSelected: "contentWizard/setIsStep2ItemSelected",
    }),

    clearProductTitle() {
      this.step2.productTitle = "";
      this.step2.selectedProduct = null
      this.setContentItem(this.step2);
    },

    selectProduct(item) {
      if(item){
        this.step2.productTitle = item.styleName + " - " + item.styleNumber;
        this.step2.selectedProduct = item.styleName + " - " + item.styleNumber;
        this.step2.title = item.styleName;
        this.step2.productId = item.styleNumber;
        this.step2.productInventoryType = item.inventoryType;
        this.step2.isItemSelected = true;
        this.selectedProduct(item);
        this.setContentItem(this.step2);
        this.setStep3([]);
      }else{
        this.step2.productTitle = ''
        this.step2.selectedProduct = null
      }
    },

    async handleProductType(e) {
      this.step2.productTitle = ''
      this.step2.selectedProduct = null
      await this.updateProductSearchTerm(e.target.value);
      this.setIsStep2ItemSelected(false);
      await this.fetchproductSearch().then(() => {
        this.setIsStep2ItemSelected(true);
      });
    },
    async updateSearchQuery(e) {
      let inputValue = e.target.value;
      if(inputValue){
        if (this.step2.selectedProduct !== inputValue) {
        this.step2.selectedProduct = null;
        }
        await this.updateProductSearchTerm(e.target.value);
      }
      else{
        this.step2.selectedProduct = null
      }
    },

    beforeDestroy(){
      this.setContentItem(this.step2);
    }
  }
};
</script>

